import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container } from "reactstrap";
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    UncontrolledTooltip,
    CardText,
    Button,
    Badge,
    Form,
    Input,
    InputGroup,
  } from "reactstrap"
  import { Link } from "react-router-dom"
  //Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import * as url from "helpers/url_helper";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";


import axios from 'axios';
import { HRConfig, formatDate, TOAST_OPTIONS } from "../../helpers/backend_helper"
import { TIMESHEETSAPPROVALS } from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader'

    const SubmittedTimesheetsUser = () => {

      toastr.options = TOAST_OPTIONS;
      const [approvals, setApprovals] = useState([]);
      const [isloading, setIsloading] = useState(false);

      useEffect(() => {
        if (localStorage.getItem("authMildUser")) {
          const obj = JSON.parse(localStorage.getItem("authMildUser"));
          const CompanyID = obj.activeCompany;
          setIsloading(true)
          axios.get(`${TIMESHEETSAPPROVALS}?$filter=employeeNo eq '${obj.uid}' and status eq 'Created' &company='${CompanyID}'`, HRConfig).then((r)=>{
            setApprovals(r.data.value)
            setIsloading(false)
          }).catch((e)=>{
            console.error(`Error fetching approvals ${JSON.stringify(e)}`);
            setIsloading(false)
          })
        }
        
        
      },[]);
      
      const handleFilter = (e) => {
        e.preventDefault();

        let obj1 = JSON.parse(localStorage.getItem("authMildUser"));
        let NavUserName = obj1.nav_username;

        const dateRange = document.getElementsByClassName('filterDate')[0]._flatpickr.selectedDates;
        const startDate = formatDate(dateRange[0]);
        const endDate = formatDate(dateRange[1]);
        const stat = document.getElementsByClassName('filterStatus')[0].value;
        const docType = document.getElementsByClassName('filterDocumentType')[0].value;
        let url = url.TIMESHEETSAPPROVALS ;
        let urlParams = '';
     
        if(stat != ''){
          urlParams = urlParams.concat( ` and status eq '${stat}' `);
        }

        if(dateRange.length > 0){
          urlParams = urlParams.concat(` and ( dateTimeSentForApproval ge ${startDate} and DateTimeSentforApproval le ${endDate} )`);
        }
        if(urlParams != ''){
          url = url + "?$filter=approverID eq '"+ NavUserName +"'" + urlParams //.substr(5);
        }else{
            url = url + "?$filter=approverID eq '"+ NavUserName  +"'"
        }
        console.log(url)
    
        axios.get(url, HRConfig).then(function(response){    setApprovals(response.data.value);    })
      }
    
      const { SearchBar } = Search;
      const columns = [
        {
          dataField: "action",
          isDummyField: true,
          text: "Action",
          formatter: actionFormatter
        },
      {
        dataField: 'approvalEntryNo',
        text: 'Approval Entry No.',
        sort: true
      }, 
      {
        dataField: 'employeeNo',
        text: 'Employee No',
        sort: true,
        formatter: noFormatter
      },
      {
        dataField: 'employeeName',
        text: 'Employee Name',
        sort: true
      }, 
      {
        dataField: 'periodRange',
        text: 'Period Range',
        sort: true
      }, 
      {
        dataField: 'month',
        text: 'Month',
        sort: true
      }, 
      {
        dataField: 'department',
        text: 'Department',
        sort: true
      },
      {
        dataField: 'approverID',
        text: 'Approver',
        sort: true
      },
      
      {
        dataField: 'dateTimeSentForApproval',
        text: 'Date Sent',
        sort: true
      },
      {
        dataField: 'status',
        text: 'Status',
        sort: true,
        formatter: statusFormatter
      }
      ];

      const defaultSorted = [{
        dataField: 'approvalEntryNo',
        order: 'desc'
      }];

      function noFormatter(cellContent, row){
        return(
          <strong>{cellContent}</strong>
        )
      }

      function actionFormatter(cellContent, row){
        return(
          <>
          <div className="d-flex gap-3">
          
            { (row.status == 'Created') && (
            
            <Link
              to={`/view-timesheet-request/${row.approvalEntryNo}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                View Details
              </UncontrolledTooltip>
            </Link>
            )}
            
            
          </div>
        </>
        )
      }
      function statusFormatter(cellContent, row) {
        if (row.status == "Canceled") {
          return (
            <div>
                <Badge className="me-2 bg-danger">
                { cellContent }
                </Badge>
            </div>
          );
        }else if (row.status == "Approved"){
          return (
            <div>
                <Badge className="me-2 bg-success">
                { cellContent }
                </Badge>
            </div>
          );
        }else if (row.status == "Created"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
          return (
            <div>
                <Badge className="me-2 bg-dark">
                { cellContent }
                </Badge>
            </div>
          );
        }
      }
      
        

   
        return (
            <>
             <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Timesheet Approvals | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Timesheet Approvals" />

               
                    
                        <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <CardTitle>Timesheet Approvals</CardTitle>
                                  <CardSubtitle className="mb-3">
                                    
                                  </CardSubtitle>

                                  {(approvals.length > 0)?(
                                  <ToolkitProvider
                                      keyField="approvalEntryNo"
                                      data={ approvals }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row className='mb-5'>
                                              <Col lg={8} className='mb-2'>
                                                <div  className="rounded bg-light d-grid gap-2">
                                                  <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                </div>
                                              </Col>
                                        
                                              <Col lg={4}> 
                                              <div className="d-grid gap-2">
                                                  
                                                </div>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='approvalEntryNo' 
                                                  data={ approvals } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>
                                  ):(
                                    <Row className="d-flex justify-content-center">
                                        <Col lg={8} >
                                        
                                            
                                            <div className="text-center">
                                                <div className="mb-4">
                                                <i className="mdi mdi-calendar-clock text-success display-4" />
                                                </div>
                                                <div>
                                                <h5>No pending approvals</h5>
                                                <p className="text-muted">
                                                        
                                                </p>
                                                </div>
                                            </div>
                                            
                                        </Col>
                                    </Row>
                                  )}

                                  
                                  
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
                  
    }

export default SubmittedTimesheetsUser;